import React from "react";
import "./DropdownSelect.css";

function DropdownSelect({ options, onSelect, value }) {
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    onSelect(selectedValue);
  };

  const selectedOption = options.find((option) => option.value === value);
  const isVariableBook = selectedOption && selectedOption.value === "BookVariaveis";

  return (
    <div className={`custom-select ${isVariableBook ? "variable-book" : ""}`}>
      <select value={value} onChange={handleSelectChange}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default DropdownSelect;
